import React from "react";
import { InputJson } from "nq-component";
import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import NavBar from "../../../../components/navigation";
import InputFactory from "../../../../components/InputFactory";
import SearchSelect from "../../../../components/searchSelect/SearchSelect";
import OfficeFormPresenter from "./OfficeFormPresenter";

class OfficeFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      advanced: false,
      region: [],
      selectedRegion: { id: "", name: "" },
    };
    this.presenter = new OfficeFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "offices";
  }

  getStateRegion() {
    return this.state.selectedRegion.id;
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const query = {
      where: {
        status: "active",
      },
    };

    const region = await findObjectUseCase().execute("Region", query);
    this.setState({ region });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.object !== this.state.object) {
      this.loadRegion();
    }
  }

  async loadRegion() {
    const { object } = this.state;
    if (object.name) {
      const query = {
        where: {
          status: "active",
        },
      };
      const region = await findObjectUseCase().execute("Region", query);
      const selected = region.find((item) => item.id === object.region);
      this.setState({
        selectedRegion: { id: selected?.id, name: selected?.name },
      });
    }
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  handleRegionChange = async (selectedRegion) => {
    this.setState({ selectedRegion });
    this.presenter.onChange();
    if (selectedRegion) {
      const query = {
        where: {
          status: "active",
          region: selectedRegion,
        },
      };
      const office = await findObjectUseCase().execute("offices", query);
      this.setState({ office, selectedOffice: "" });
    }
  };

  onChange(value, field) {
    this.setState({ [field]: value });
  }

  render() {
    const object = this.state.object;
    const { region } = this.state;
    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    const label = this.getObjectId() === undefined ? "Add New" : "Update ";
    if (!schema) return <h1>no schema</h1>;
    console.log("test: ", this.state.selectedRegion);
    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-3 text-capitalize">
                {(schema.label || this.getCollectionName()) + " Details"}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.presenter.save();
                  }}
                >
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChangeObject.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <>
                        <div className="p-0">
                          <label>
                            Name <span className="text-danger">*</span>
                          </label>
                          <InputFactory
                            type="String"
                            field="name"
                            object={object}
                            placeholder="name"
                            onChange={this.onChange.bind(this)}
                            required={true}
                          />
                        </div>
                        <div className="p-0">
                          <label>
                            Description <span className="text-danger">*</span>
                          </label>
                          <InputFactory
                            type="String"
                            field="description"
                            object={object}
                            placeholder="description"
                            onChange={this.onChange.bind(this)}
                            required={true}
                          />
                        </div>
                        <div className="p-0">
                          <label>
                            OCOM <span className="text-danger">*</span>
                          </label>
                          <SearchSelect
                            focus={true}
                            value={this.state.selectedRegion?.name}
                            onChange={this.handleRegionChange}
                            disabled={region.length < 1}
                            options={region.map((officeItem) => ({
                              label: officeItem.name,
                              value: {
                                id: officeItem?.id,
                                name: officeItem?.name,
                              },
                            }))}
                          />
                        </div>
                      </>
                    )}
                  </div>
                  <div className="mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary fs-sm me-3"
                    >
                      <i className="bi bi-file-earmark-check me-2"></i>
                      {label}
                    </button>
                    <button
                      type="button"
                      className="btn btn-light fs-sm"
                      onClick={this.onClickBack.bind(this)}
                    >
                      GO BACK
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(OfficeFormPage);
